import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62a594dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "header-label" }
const _hoisted_3 = { class: "loader-div-sm" }
const _hoisted_4 = ["src"]

import VueDragResize from "vue-drag-resize";
import {
  ElButton,
  ElScrollbar,
  ElTooltip,
  ElConfigProvider,
} from "element-plus";
import { computed, onMounted, onUnmounted, ref, watch, nextTick } from "vue";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";
import i18n from "@/core/i18n/i18n";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const MIN_W = 678;
const MIN_H = 400;
const POPUP_BODY_OFFSET = 97;


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupWindow',
  props: {
    dialog: { type: Boolean },
    size: {},
    live: {},
    fixed: { type: Boolean },
    fixedHeight: { type: Boolean },
    lazyLoad: { type: Boolean },
    moved: { type: Boolean },
    showFooterButton: { type: Boolean }
  },
  emits: [
  "close",
  "updateHeight",
  "lazyLoad",
  "copyJson",
  "downloadLogsAsText",
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = i18n.global;

const emit = __emit;

const viewport = ref<HTMLElement | null>(null);
const getScreen = () => document.getElementById("app");
const getParent = () => document.getElementById("content");

const width = ref(setWidthSize());
const height = ref(setHeightSize());
const x = ref(computeX());
const y = ref(computeY());
const z = ref(900);
const maximized = ref(false);
const counter = ref(0);

const oldX = ref<number | undefined>();
const oldY = ref<number | undefined>();
const oldWidth = ref<number | undefined>();
const oldHeight = ref<number | undefined>();

const scrollHeight = computed(() => height.value - 230);

const scrollbar = ref<any>();

const loading = ref(false);

function getViewportSize() {
  const vp = viewport.value;
  const vw = vp?.clientWidth ?? window.innerWidth;
  const vh = vp?.clientHeight ?? window.innerHeight;
  return { vw, vh };
}

function clampToViewport(next: {
  left: number;
  top: number;
  width: number;
  height: number;
}) {
  const { vw, vh } = getViewportSize();

  let w = Math.max(next.width, MIN_W);
  let h = Math.max(next.height, MIN_H);

  let left = Math.max(0, next.left);
  let top = Math.max(0, next.top);

  if (left + w > vw) {
    w = Math.min(w, vw - left);
    if (left + w > vw) {
      left = Math.max(0, vw - w);
    }
  }

  if (top + h > vh) {
    h = Math.min(h, vh - top);
    if (top + h > vh) {
      top = Math.max(0, vh - h);
    }
  }

  x.value = left;
  y.value = top;
  width.value = w;
  height.value = h;
}

function setWidthSize() {
  switch (props.size) {
    case "sm":
      return MIN_W;
    case "m":
      return getParent() ? (4 * getParent()!.clientWidth) / 6 : 1330;
    case "l":
      return getParent() ? (5 * getParent()!.clientWidth) / 6 : 1750;
    default:
      return getParent() ? (3 * getParent()!.clientWidth) / 6 : MIN_W;
  }
}

function setHeightSize() {
  switch (props.size) {
    case "sm":
      return MIN_H;
    case "m":
      return getParent() ? (4 * getParent()!.clientHeight) / 6 : 710;
    case "l":
      return getParent() ? (5 * getParent()!.clientHeight) / 6 : 900;
    default:
      return getParent() ? (3 * getParent()!.clientHeight) / 6 : MIN_H;
  }
}

watch(
  () => props.live,
  () => {
    if (scrollbar.value && props.live !== 0) {
      scrollbar.value.setScrollTop(Number.MAX_SAFE_INTEGER);
    }
  }
);

const maximizeTooltip = computed((): string =>
  maximized.value ? t("Flow.RestoreWindow") : t("Flow.MaximizeWindow")
);

function triggerLazyLoad(event: any) {
  if (props.lazyLoad) {
    const mainScreen = document.getElementById("main-screen");
    const distanceToBottom =
      scrollbar.value && mainScreen
        ? event.scrollTop +
          (height.value - POPUP_BODY_OFFSET) -
          mainScreen.offsetHeight
        : -1;
    if (distanceToBottom >= 0 && !loading.value) {
      loading.value = true;
      setTimeout(() => {
        emit("lazyLoad");
        loading.value = false;
      }, 1000);
    }
  }
}

function computeX() {
  if (props.moved) {
    const p = getParent();
    return p ? p.offsetLeft - p.clientWidth / 2 : 0;
  }
  const s = getScreen();
  if (s) {
    return (s.clientWidth - width.value) / 2;
  }
  const p = getParent();
  return p ? p.offsetLeft : 172;
}

function computeY() {
  const s = getScreen();
  if (s) {
    return (s.clientHeight - height.value) / 2;
  }
  const p = getParent();
  return p ? p.offsetTop : 52;
}

watch(
  () => scrollHeight.value,
  () => {
    emit("updateHeight", scrollHeight.value);
  }
);

function maximizeMinimizeWindow() {
  if (maximized.value) {
    width.value = oldWidth.value ?? setWidthSize();
    height.value = oldHeight.value ?? setHeightSize();
    maximized.value = false;
    const p = getParent();
    x.value = oldX.value ?? p?.offsetLeft ?? 0;
    y.value = oldY.value ?? p?.offsetTop ?? 0;
    z.value -= 1000;
  } else {
    const p = getParent();
    width.value = p ? p.clientWidth : window.innerWidth;
    height.value = p ? p.clientHeight : window.innerHeight;
    x.value = p?.offsetLeft ?? 0;
    y.value = p?.offsetTop ?? 0;
    maximized.value = true;
    z.value += 1000;
  }

  clampToViewport({
    left: x.value,
    top: y.value,
    width: width.value,
    height: height.value,
  });
  counter.value++;
}

function onActivated() {
  z.value += 100;
}

function onDeactivated() {
  z.value -= 100;
}

function positionChange(obj: {
  left: number;
  top: number;
  width: number;
  height: number;
}) {
  if (!maximized.value) {
    oldWidth.value = obj.width;
    oldHeight.value = obj.height;
    oldX.value = obj.left;
    oldY.value = obj.top;
    width.value = obj.width;
    height.value = obj.height;
    x.value = obj.left;
    y.value = obj.top;

    clampToViewport({
      left: x.value,
      top: y.value,
      width: width.value,
      height: height.value,
    });
  }
  const mainScreen = document.getElementById("main-screen");
  if (mainScreen) {
    if (
      mainScreen.offsetHeight <= height.value - POPUP_BODY_OFFSET &&
      !loading.value &&
      props.lazyLoad
    ) {
      loading.value = true;
      setTimeout(() => {
        emit("lazyLoad");
        loading.value = false;
      }, 1000);
    }
  }
}

function mousedown(e: MouseEvent) {
  e.stopPropagation();
}

function mouseup(e: MouseEvent) {
  e.preventDefault();
}

function updateWindow() {
  if (maximized.value && props.dialog) {
    const p = getParent();
    width.value = p?.clientWidth || window.innerWidth;
    height.value = p?.clientHeight || window.innerHeight;
    x.value = p?.offsetLeft ?? 0;
    y.value = p?.offsetTop ?? 0;
    clampToViewport({
      left: x.value,
      top: y.value,
      width: width.value,
      height: height.value,
    });
    counter.value++;
  } else if (
    !maximized.value &&
    props.dialog &&
    getParent() &&
    (getParent()!.clientWidth < width.value ||
      getParent()!.clientHeight < height.value)
  ) {
    maximizeMinimizeWindow();
  } else {
    clampToViewport({
      left: x.value,
      top: y.value,
      width: width.value,
      height: height.value,
    });
  }
}

onMounted(async () => {
  window.addEventListener("resize", updateWindow);
  await nextTick();
  clampToViewport({
    left: x.value,
    top: y.value,
    width: width.value,
    height: height.value,
  });
});
onUnmounted(() => {
  window.removeEventListener("resize", updateWindow);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), { "z-index": 4000 }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "popup-viewport",
        ref_key: "viewport",
        ref: viewport
      }, [
        (_ctx.dialog)
          ? (_openBlock(), _createBlock(_unref(VueDragResize), {
              isActive: false,
              key: counter.value,
              w: width.value,
              h: height.value,
              z: z.value,
              x: x.value,
              y: y.value,
              minw: MIN_W,
              minh: MIN_H,
              stickSize: 4,
              parentLimitation: true,
              onResizestop: positionChange,
              onResizing: positionChange,
              onDragging: positionChange,
              onDragstop: positionChange,
              onActivated: onActivated,
              onDeactivated: onDeactivated
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", {
                    class: "header background-fb",
                    onDblclick: maximizeMinimizeWindow
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _renderSlot(_ctx.$slots, "header-label")
                    ]),
                    _createElementVNode("div", {
                      class: "button-container",
                      onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                      onMouseup: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createVNode(_unref(ElTooltip), {
                        effect: "custom",
                        content: _unref(t)('Flow.DownloadLogsAsText'),
                        placement: "bottom",
                        "popper-class": "pw-tooltip",
                        teleported: true,
                        "popper-options": { strategy: 'fixed' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            type: "text",
                            id: "download-logs",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('downloadLogsAsText')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, {
                                style: {"color":"#5022a6"},
                                icon: _unref(faDownload)
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["content"]),
                      _createVNode(_unref(ElTooltip), {
                        effect: "custom",
                        content: maximizeTooltip.value,
                        placement: "bottom",
                        "popper-class": "pw-tooltip",
                        teleported: true,
                        "popper-options": { strategy: 'fixed' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            type: "text",
                            id: "maximize-popup",
                            onClick: maximizeMinimizeWindow
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, {
                                style: {"color":"#5022a6"},
                                icon: maximized.value ? 'window-restore' : 'window-maximize'
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["content"]),
                      _createVNode(_unref(ElButton), {
                        type: "text",
                        id: "close-popup",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            style: {"color":"#5022a6"},
                            icon: "times"
                          })
                        ]),
                        _: 1
                      })
                    ], 32)
                  ], 32),
                  _createElementVNode("div", {
                    onMousedown: mousedown,
                    onMouseup: mouseup
                  }, [
                    _createVNode(_unref(ElScrollbar), {
                      "max-height": (height.value - POPUP_BODY_OFFSET).toString() + 'px',
                      onScroll: triggerLazyLoad,
                      ref_key: "scrollbar",
                      ref: scrollbar,
                      onMouseup: mouseup
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          id: "main-screen",
                          class: "modal-body content-body background-fb",
                          style: _normalizeStyle([{"margin":"12px"}, 
                  _ctx.fixedHeight
                    ? { height: `${(height.value - POPUP_BODY_OFFSET).toString()}px` }
                    : {
                        minHeight: `${(
                          height.value - POPUP_BODY_OFFSET
                        ).toString()}px`,
                      }
                ])
                        }, [
                          _renderSlot(_ctx.$slots, "main")
                        ], 4)
                      ]),
                      _: 3
                    }, 8, ["max-height"]),
                    _withDirectives(_createElementVNode("div", _hoisted_3, [
                      _createElementVNode("img", {
                        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                        alt: "Loading...",
                        class: "loader-logo-40"
                      }, null, 8, _hoisted_4)
                    ], 512), [
                      [_vShow, loading.value && _ctx.lazyLoad]
                    ])
                  ], 32),
                  _createElementVNode("div", {
                    class: "modal-footer footer",
                    onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                    onMouseup: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _renderSlot(_ctx.$slots, "footer"),
                    (_ctx.showFooterButton)
                      ? (_openBlock(), _createBlock(_unref(ElButton), {
                          key: 0,
                          type: "primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('copyJson'))),
                          class: "btn-oneTeg2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("Flow.CopyJson")), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 32)
                ])
              ]),
              _: 3
            }, 8, ["w", "h", "z", "x", "y"]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _: 3
  }))
}
}

})